import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';

import AppRouter from './router';

const logoSrc = 'https://s3.ap-northeast-2.amazonaws.com/b2b-barcode-template/prod/splashlogo.png';

@inject('packageStore')
@observer
export default class AppContainer extends Component {

  constructor(props) {
    super(props);
    
    this.state = {
      renderSplashScreen: true
    }
  }

  componentWillMount() {
    this.hideSplashScreen();
  }

  shouldComponentUpdate() {
    return true;
  };

  hideSplashScreen = () => {
    const thisComponent = this;
    setTimeout(function() {
      thisComponent.setState({
        renderSplashScreen: false
      });
    }, 1200)
  }

  getDisplayStyle = () => {
    const { renderSplashScreen } = this.state;
    return { 
      splash: { 
        display: renderSplashScreen ? 'flex' : 'none'
      },
      content: {
        display: renderSplashScreen ? 'none' : 'block'
      }
    };
  }

  render() {
    const renderStyle = this.getDisplayStyle();
    return (
      <div>
        <div className="splash-screen" style={renderStyle.splash}>
          <img className="splash-screen__logo" alt="splash-img" src={logoSrc} />
        </div>
        <div className="content-screen" style={renderStyle.content}>
          <AppRouter />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App.js